module.exports = __webpack_public_path__ + "static/ux_5_eg-c655d34d75b53b17a3be4f918b582b1d.png";